var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 19,
    viewBox: "0 0 98 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.919 0.29194V7.47772H22.9079V0.29194L19.2617 0.288696V18.4071H22.9079V10.6234H32.919V18.4071H36.5711V0.29194H32.919Z",
    fill: "#718087"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4258 0.292603V18.4034H97.4224L95.3964 15.2151H85.0823V10.624H95.0695V7.55306H85.0823V3.40632H95.3791L97.364 0.292603H81.4258Z",
    fill: "#718087"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70849 0.28772C1.91565 0.28772 0 2.59351 0 5.94858V12.7117C0 16.5944 2.46868 18.4072 5.68954 18.4072L17.1292 18.4061L15.0085 15.0944H6.39627C4.56667 15.0944 3.76958 14.4331 3.76958 12.3854V6.24946C3.76958 4.26997 4.4406 3.49776 6.44497 3.49776H15.0983L17.1346 0.28772H5.70849Z",
    fill: "#718087"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4234 0.283257C63.2329 0.283257 60.9877 1.59985 60.9877 4.9863V5.85645C60.9877 9.38684 63.1479 10.7337 65.3092 10.7429H72.8955C73.6834 10.7429 74.3235 10.8739 74.3235 12.2056L74.3224 13.7441C74.3024 14.9406 73.7055 15.2144 72.8684 15.2144H62.8882L60.8438 18.4028H73.1033C76.0595 18.4028 78.0666 16.9319 78.0666 13.5347V12.2863C78.0666 9.00156 76.2018 7.44956 73.3105 7.44956H66.0668C65.2638 7.44956 64.7042 7.2304 64.7042 6.04098V4.78824C64.7042 3.77523 65.0879 3.40563 66.0235 3.40563L75.5281 3.40184L77.5146 0.278931L65.4234 0.283257Z",
    fill: "#718087"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1648 0.292603L38.5742 18.4067H42.6344L44.3076 14.6658H53.6428L55.3106 18.4067H59.3886L50.778 0.292603H47.1648ZM48.9663 4.05352L52.2672 11.5824H45.6864L48.9663 4.05352Z",
    fill: "#718087"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChase);
export default __webpack_public_path__ + "static/media/Chase.d31a9aa0476f713de62f794c5ca3ebdd.svg";
export { ForwardRef as ReactComponent };